import { dramas, type Drama } from '@/mocks/dramas';
import { episodes, type Episode } from '@/mocks/episodes';

export const getDramaById = (id: string): Drama | undefined => dramas.find((d) => d.id === id);

export const getFeaturedDramas = (): Drama[] => dramas.filter((d) => d.featured);

export const getRelatedDramas = (excludeId: string, count = 4): Drama[] =>
  dramas.filter((d) => d.id !== excludeId).slice(0, count);

export const getEpisodesByDrama = (dramaId: string): Episode[] =>
  episodes
    .filter((e) => e.dramaId === dramaId)
    .sort((a, b) => a.number - b.number);

export const getEpisodeById = (id: string): Episode | undefined => episodes.find((e) => e.id === id);

export const getAiredEpisodes = (dramaId: string): Episode[] =>
  getEpisodesByDrama(dramaId).filter((e) => e.aired);

export const getLatestEpisodes = (count = 6): Episode[] =>
  [...episodes]
    .filter((e) => e.aired)
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, count);

export const searchEpisodes = (keyword: string): Episode[] => {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return episodes.filter(
    (e) => e.title.toLowerCase().includes(q) || e.summary.toLowerCase().includes(q),
  );
};

export const searchDramas = (keyword: string): Drama[] => {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return dramas.filter(
    (d) =>
      d.title.toLowerCase().includes(q) ||
      d.alias.toLowerCase().includes(q) ||
      d.cast.some((c) => c.toLowerCase().includes(q)) ||
      d.genres.some((g) => g.toLowerCase().includes(q)),
  );
};

export const formatDate = (value: string): string => {
  if (!value) return '--';
  const parts = value.split('-');
  if (parts.length < 3) return value;
  return `${parts[0]}-${parts[1]}-${parts[2]}`;
};

export const toPlayEpisodeId = (episodeId: string): string => episodeId;